import { Form, FormTheme } from '@kanda-libs/ks-component-ts';
import { Loader } from '@kanda-libs/ks-design-library';
import { CLASS_NAMES } from './constants';
import EnquiryContactDetailsFormFields from './ContactFields';
import useEnquiryContactDetailsForm from './useEnquiryContactDetailsForm';

const EnquiryContactDetails: React.FunctionComponent = function () {
  const { form, onSubmit, isSubmitting } = useEnquiryContactDetailsForm();
  return (
    <Form id="enquiry-contact-details" form={form} onSubmit={onSubmit}>
      <FormTheme variant="streamline">
        <div className="flex flex-col mt-2">
          <h1 className={CLASS_NAMES.header}>Provide contact information</h1>
          <h3 className={CLASS_NAMES.subheader}>
            Let us know how we can get in contact with you and the address where
            the work will take place
          </h3>
          <EnquiryContactDetailsFormFields />
        </div>
        <Loader isLoading={isSubmitting} />
      </FormTheme>
    </Form>
  );
};

export default EnquiryContactDetails;
